"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlShortCut = void 0;
const react_1 = __importStar(require("react"));
const utils_1 = require("./utils");
const ControlShortCut = ({ keyboardKey, onAction }) => {
    const onActionHandler = (0, react_1.useCallback)((event) => {
        if ((event.ctrlKey || event.metaKey) && event.key === keyboardKey.toLowerCase()) {
            event.preventDefault();
            onAction === null || onAction === void 0 ? void 0 : onAction(event);
        }
    }, [keyboardKey, onAction]);
    (0, react_1.useEffect)(() => {
        document.addEventListener('keydown', onActionHandler);
        return () => {
            document.removeEventListener('keydown', onActionHandler);
        };
    }, [onActionHandler]);
    return (react_1.default.createElement("kbd", { className: "font-sans font-medium text-secondary-500" },
        react_1.default.createElement("abbr", { title: "Command", className: "no-underline mr-1" }, (0, utils_1.getPlatform)() === utils_1.PlatformEnum.MacOS ? '⌘' : 'Ctrl'),
        react_1.default.createElement("span", { className: "uppercase" }, keyboardKey)));
};
exports.ControlShortCut = ControlShortCut;
//# sourceMappingURL=ControlShortCut.js.map